import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/About.module.css";
import exp from "../img/Experience.svg";
import project from "../img/Projects.svg";
import multiple from "../img/Multiple.svg";

const About = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(sectionRef.current); // trigger only once
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(sectionRef.current);
  }, []);

  return (
    <div
    id="about"
       ref={sectionRef}
  className={`${styles.about_container} ${visible ? styles.animate : ""}`}
    >
      <div className={styles.about_content}>
        <h2>About Relico Ventures</h2>
        <p>
          <strong>Relico Ventures LLP</strong> is a premier management
          consultancy firm led by industry veteran Rajesh Relan, offering
          strategic guidance across diverse business sectors.
        </p>
        <p>
          With a legacy spanning over 35 years in the financial services sector,
          including more than two decades in the Indian and International
          Insurance industry, we bring unparalleled expertise to every
          engagement.
        </p>
        <p>
          Relico Ventures provides comprehensive consultancy and specialized
          advisory and risk management solutions to corporate organizations.
        </p>

        <div className={styles.about_grid}>
          <div>
            <img src={exp} alt="exp" />
            <div>
              <h3>35+</h3>
              <p>Years of Experience</p>
            </div>
          </div>
          <div>
            <img src={project} alt="project" />
            <div>
              <h3>100+</h3>
              <p>Successful Projects</p>
            </div>
          </div>
          <div>
            <img src={multiple} alt="industries" />
            <div>
              <h3>Multiple</h3>
              <p>Industries Served</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
